import { useState, useMemo, useEffect } from "react";
import { Typography, Grid2 as Grid } from "@mui/material";
import moment from "moment";

import { useNavigate } from "react-router-dom";
import { Loading } from "../../components/loading/Loading";
import DataTable from "../../components/admin/TableInversionistas";
import InfoCard from "../../components/cards/InfoCard";
import { getUsers } from "../../actions/users";
import { isEmpty } from "../../components/common/helpers";

import { useSelector, useDispatch } from "react-redux";

const ListAdmin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const users = useSelector(state => state.users.users);
  const loadingUsers = useSelector(state => state.users.loading);

  const updatesServices = moment().format("DD MMMM YYYY");

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  // State moved from TableInversionistas
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { processedUsers, stats } = useMemo(() => {
    if (!users) return { processedUsers: [], stats: { investors: 0, pending: 0, totalInv: 0, totalCont: 0 } };

    let investorsCount = 0;
    let pendingCount = 0; // Logic for pending verification needs to be defined, assuming 0 for now or based on some status
    let totalInvSum = 0;
    let totalContSum = 0;

    const processed = users.filter(user =>
      user.datos_empresas &&
      user.datos_empresas.length > 0 &&
      user.datos_empresas[0].inversiones &&
      user.datos_empresas[0].inversiones.length > 0
    ).map(user => {
      investorsCount++;
      const inversiones = user.datos_empresas[0].inversiones;
      let total = 0;
      let services = 0;

      inversiones.forEach(inv => {
        // Logic from Inversiones.js
        if (!isEmpty(inv.servicio) && inv.status === 1) {
          services += inv.monto;
        } else {
          total += inv.monto; // Assuming 'total' in table refers to investment total
        }

        // Check for pending status
        if (inv.status === 0) pendingCount++;
      });

      totalInvSum += total;
      totalContSum += services;

      return {
        id: user._id,
        name: user.datos_empresas[0].razon_social,
        email: user.datos_empresas[0].email,
        rfc: user.datos_empresas[0].rfc || "N/A",
        total: total, // Total Invertido
        services: services, // Total Servicios
        link: `/admin/detalle/${user._id}` // Assuming link to detail
      };
    });

    return {
      processedUsers: processed,
      stats: {
        investors: investorsCount,
        pending: pendingCount,
        totalInv: totalInvSum,
        totalCont: totalContSum
      }
    };
  }, [users]);

  const statistics = [
    { title: "Inversionistas", value: stats.investors, info: "Registrados en la plataforma" },
    { title: "Pendientes de verificar", value: stats.pending, info: "Requiere aprobación", link: "/admin/inversiones?filter=pending" },
    { title: "Total invertido", value: `$${stats.totalInv.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, info: "Suma de todas las inversiones" },
    { title: "Total contratado", value: `$${stats.totalCont.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, info: "Suma de contratos" },
  ];

  const results = useMemo(() => {
    const toSend = processedUsers || [];
    if (search == "") return toSend;
    const term = search.toLowerCase().trim();
    return toSend.filter(item =>
      item.name.toLowerCase().includes(term) ||
      item.email.toLowerCase().includes(term) ||
      item.rfc.toLowerCase().includes(term)
    )
  }, [search, processedUsers]);

  const handleChangePage = newPage => {
    setPage(newPage);
  };

  const totalPages = Math.ceil(results.length / rowsPerPage);

  const irA = where => {
    navigate(where);
  }

  if (loadingUsers) {
    return <Loading />
  }

  return (
    <Grid container mt={{ xs: 10, md: 12 }} spacing={2}>
      <Grid size={12}>
        <Typography mt={3} variant="h6" color="primary">
          Panel de administración de inversionistas
        </Typography>
        <Typography
          variant="body2"
          color="#737791"
          sx={{ marginBottom: 1 }}
        >
          Información actualizada al {updatesServices}
        </Typography>
      </Grid>
      <Grid size={12}>
        <Grid container spacing={2} sx={{ alignItems: "stretch", marginBottom: 2 }}>
          {statistics.map((statistic, index) => (
            <Grid
              key={`statistic${index}`}
              size={{ xs: 12, md: 6, lg: 3 }}
              sx={{ marginBottom: 2 }}
            >
              <InfoCard item={statistic} handleLink={() => irA(statistic?.link ?? "/")} />
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid size={12}>
        <Typography mt={3} variant="h6" color="primary">
          Lista de inversionistas
        </Typography>
        <Typography
          variant="body2"
          color="#737791"
          sx={{ marginBottom: 1 }}
        >
          Gestiona la información y aprobación de RFC
        </Typography>
      </Grid>
      <DataTable
        results={results}
        search={search}
        setSearch={setSearch}
        page={page}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        handleChangePage={handleChangePage}
        irA={irA}
      />
    </Grid>
  );
}

export default ListAdmin;
